import { ITabDef } from '../../../../helpers/tabErrorUtils'

export type IEventFormTabDef = ITabDef

/**
 * Canonical tab definitions in display order. `Local` is shown by the modal only when
 * the event's format needs an address (see `needsLocation`) — filtered by `key`, not by
 * array position, so reordering or adding tabs later can't silently hide the wrong one.
 */
export const EVENT_TAB_DEFS: IEventFormTabDef[] = [
  {
    key: 'general',
    label: 'Geral',
    fields: [
      'name',
      'slug',
      'format',
      'types',
      'course_ids',
      'thumb',
      'thumb_wide',
      'video',
      'remove_video',
      'date_start',
      'is_multiday',
      'date_end',
      'time_start',
      'time_end',
      'visible',
      'use_nfc'
    ]
  },
  { key: 'tickets', label: 'Ingressos', fields: ['tickets', 'min_installment_value', 'parking_ticket_type_id'] },
  { key: 'content', label: 'Conteúdo', fields: ['copy', 'target_audience', 'topics', 'use_term', 'term'] },
  {
    key: 'engagement',
    label: 'Depoimento & Dúvidas',
    fields: ['testimonial_title', 'testimonial_videos', 'testimonial_existing', 'use_testimonial', 'use_help_form']
  },
  { key: 'faq', label: 'FAQ', fields: ['faqs'] },
  { key: 'marketing', label: 'Marketing', fields: ['active_campaign_lead_lists', 'active_campaign_buyer_lists'] },
  { key: 'professionals', label: 'Profissionais', fields: ['professionals'] },
  // ABRA-317 — antes de "Local", que tem de continuar a última (some quando o formato não tem endereço).
  { key: 'establishments', label: 'Produtos e Serviços', fields: ['establishments'] },
  {
    key: 'location',
    label: 'Local',
    fields: [
      'zipcode',
      'street',
      'number',
      'complement',
      'neighborhood',
      'city',
      'state',
      'latitude',
      'longitude',
      'place_id',
      'place_name'
    ]
  }
]

export { countErrorsPerTab, firstTabWithErrors, unmappedErrorMessages } from '../../../../helpers/tabErrorUtils'
